import { chakra, ChakraProps } from "@chakra-ui/react";
import { SHIELD_GLYPH_PATH } from "./shieldGlyphPath";

// Secondary accent used alongside the partner accent, pairing the Zcash gold
// with the Solana violet the way BullSilhouette does for ANSEM.
const VIOLET = "#9945ff";

interface ShieldGlyphProps extends ChakraProps {
  /** Partner accent (hex) that the shield glows in. */
  accent: string;
}

// Shielded-ZEC watermark for the /zcash Drip page. The path holds both the
// shield and the "Z", so it needs fill-rule "evenodd" to punch the letter out
// instead of filling over it. Layered the same way as BullSilhouette: a blurred
// bloom halo, the crisp gradient glyph, and a whisper-faint white rim.
export const ShieldGlyph = ({ accent, ...props }: ShieldGlyphProps) => (
  <chakra.svg viewBox="0 0 600 700" role="img" aria-label="Zcash shield" {...props}>
    <defs>
      <linearGradient id="zcash-shield-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor={accent} />
        <stop offset="100%" stopColor={VIOLET} />
      </linearGradient>
      <filter id="zcash-shield-bloom" x="-40%" y="-40%" width="180%" height="180%">
        <feGaussianBlur stdDeviation="16" />
      </filter>
    </defs>
    {/* Soft bloom halo. */}
    <path
      d={SHIELD_GLYPH_PATH}
      fillRule="evenodd"
      fill="url(#zcash-shield-grad)"
      filter="url(#zcash-shield-bloom)"
      opacity={0.4}
    />
    {/* Crisp gradient glyph. */}
    <path
      d={SHIELD_GLYPH_PATH}
      fillRule="evenodd"
      fill="url(#zcash-shield-grad)"
      opacity={0.9}
    />
    {/* Whisper-faint rim for a constructed, premium edge. */}
    <path
      d={SHIELD_GLYPH_PATH}
      fill="none"
      stroke="#ffffff"
      strokeOpacity={0.08}
      strokeWidth={1.2}
    />
  </chakra.svg>
);
